<template>
  <div :id="prefixID+'-gis2dViewer'" class="gis2dViewer">
    <div :id="prefixID+'-gisMap'" class="gisMap"></div>
    <div :id="prefixID+'-logoDiv'" class="esri-component esri-widget">
      <img height="40" src="img/brand/arcadisFullLogo.png">
    </div>
    <div :id="prefixID+'-screenshotBtnDiv'" class="screenshotBtnDiv esri-widget">
      Start to screenshot by clicking the button below:
      <br>
      <br>
      <button
        :id="prefixID+'-screenshotBtn'"
        class="esri-button"
        aria-label="Select screenshot area"
        title="Select screenshot area"
        @click="screenshotBtnClick">
        Capture
      </button>
    </div>
    <div :id="prefixID+'-screenshotDiv'" class="screenshotDiv hide">
      <img :id="prefixID+'-screenshotImage'" class="js-screenshot-image" />
      <div>
        <label>Set a text to be displayed on the image: </label>
        <input type="text" placeholder="Image text" :id="prefixID+'-textInput'" autofocus />
      </div>
      <button
        :id="prefixID+'-downloadBtn'"
        class="btn btn-primary"
        aria-label="Download image"
        title="Download image">
        Download image
      </button>
      <button
        :id="prefixID+'-closeBtn'"
        class="btn btn-secondary"
        aria-label="Back to webmap"
        title="Back to webmap"
        @click="screenshotCloseClick">
        Back to webmap
      </button>
    </div>
    <div :id="prefixID+'-maskDiv'" class="hide maskDiv screenshotCursor"></div>
    <div :id="prefixID+'-fullscreenDiv'" class="fullscreenDiv"></div>
  </div>
</template>

<script>
  /*eslint-disable*/
  /*
    This 2D Viewer module is intended to be used with pre-sized sections.

    Issues will be encountered in the following widgets if not:
    1. Fullscreen widget (Going out from Full Screen mode will cause the whole component not to render properly)

  */
  import { loadModules, loadCss } from 'esri-loader';
  loadCss("https://js.arcgis.com/4.16/esri/themes/dark/main.css")

  export default {
    name: 'GIS2DViewer',
    props: {
      width: String,
      height: String,
      appId: String,
      webMapId: String
    },
    data() {
      return {
        portalURL: "https://au1gis.solutions.arcadis.com/arcgis",
        webmap: "",
        defaultWidth: this.width?this.width:"95vw",
        defaultHeight: this.height?this.height:"95vh",
        screenshotBtnDiv: null,
        expandScreenshot: null,
        expandLayerList: null,
        layerList: null,
        legendList: null,
        expandLegend: null,
        baseMapGallery: null,
        expandBaseMapGallery: null,
        search: null,
        expandSearch: null,
        fullscreenDiv: null,
        fullscreen: null,
        prefixID: null,
        home: null
      }
    },
    computed: {

    },
    created() {
      this.prefixID = this.makeID(10)
      // loadCss("https://js.arcgis.com/4.12/esri/themes/dark/main.css")
    },
    mounted() {
      const current = this;
      console.log(current.prefixID);
      // var screenshotBtnDiv = document.getElementById("screenshotBtnDiv")
      // var containerStyle = document.getElementById("gis2dViewer").parentNode.style
      // if (!containerStyle.width) {
      //   document.getElementById("gisMap").style.width=current.defaultWidth
      // }
      // else {
      //   document.getElementById("gisMap").style.width=containerStyle.width
      // }
      // if (!containerStyle.height) {
      //   document.getElementById("gisMap").style.height=current.defaultHeight
      // }
      // else {
      //   document.getElementById("gisMap").style.height=containerStyle.height
      // }
      // document.getElementById("gis2dviewer").style.width=current.width
      // document.getElementById("gis2dviewer").style.height=current.height
      loadModules([
        "esri/WebMap",
        "esri/views/MapView",
        "esri/config",
        "esri/identity/IdentityManager",
        "esri/identity/OAuthInfo",
        "esri/portal/Portal",
        "esri/portal/PortalItem",
        "esri/widgets/Expand",
        "esri/widgets/Fullscreen",
        // "dojo/on",
        "esri/widgets/LayerList",
        "esri/widgets/Legend",
        "esri/widgets/BasemapGallery",
        "esri/widgets/Search",
        "esri/widgets/Home",
      ],
      { css: true })
      .then(([
        WebMap,
        MapView,
        esriConfig,
        esriId,
        OAuthInfo,
        Portal,
        PortalItem,
        Expand,
        Fullscreen,
        // on,
        LayerList,
        Legend,
        BasemapGallery,
        Search,
        Home
      ]) => {
        esriConfig.portalUrl = current.portalURL



        // if(sessionStorage.arcGISToken){
        //   // var parentWindow = (window.opener && window.opener.parent) ? window.opener.parent : window
        //   // parentWindow.oauthCallback(sessionStorage.arcGISToken);
        //   // console.log("went here");
        //
        //   esriId.setOAuthRedirectionHandler(function(info)
        //   {
        //     console.log("went here");
        //    // Execute custom logic then perform redirect
        //    window.location = info.authorizeUrl + "?" + ioquery.objectToQuery(info.authorizeParams);
        //   });
        // }
        // else {
          var authInfo = new OAuthInfo({
            appId: current.appId,
            portalUrl: current.portalURL,
            popup: false
          });
          esriId.registerOAuthInfos([authInfo]);
          var portal = new Portal({
            url: current.portalURL
          });

          let portalItem = new PortalItem({
            // id: "8026257b9b0d4c7b9539ec91eed63492",
            // id: "8026257b9b0d4c7b9539ec91eed63492",
            id: current.webMapId,
            portal: portal
          });
          portal.authMode = "immediate";
          portal.load().then(function(portalResult) {
            // block to add bespoke functionality for authentication ruleset if ever
            // console.log(portalResult);
          });
        // }


        esriId
          .checkSignInStatus(current.portalURL + "/sharing/rest")
          .then(function() {
            console.log("signed in");
            current.webmap = new WebMap({
              portalItem: portalItem
            });
            current.webmap.load()
              .catch((error)=>{
                console.error(error);
              })
              .then(()=>{
                current.view = new MapView({
                  container: current.prefixID + "-gisMap",
                  map: current.webmap,
                  highlightOptions: {
                    color: [0, 255, 255],
                    fillOpacity: 0.6
                  }
                })
                current.screenshotBtnDiv = document.getElementById(current.prefixID + "-screenshotBtnDiv")
                current.expandScreenshot = new Expand({
                  view: current.view,
                  expandIconClass: "fa fa-camera",
                  expandTooltip: "Screen Shot",
                  collapseTooltip: "Screen Shot",
                  content: current.screenshotBtnDiv,
                  group: "top-right"
                })
                current.fullscreenDiv = document.getElementById(current.prefixID + "-fullscreenDiv")
                current.fullscreen = new Fullscreen({
                  container: current.fullscreenDiv,
                  view: current.view
                });
                current.layerList = new LayerList({
                  view: current.view,
                  listItemCreatedFunction: function(event) {
                    var item = event.item;
                    item.actionsSections = [
                      [{
                        title: "Zoom to layer",
                        className: "fa fa-search",
                        id: "full-extent"
                      }]
                    ]
                  }
                });
                current.layerList.on("trigger-action", function(event) {
                  current.view.goTo(event.item.layer.fullExtent);
                });
                current.expandLayerList = new Expand({
                  view: current.view,
                  expandTooltip: "Layer List",
                  collapseTooltip: "Layer List",
                  content: current.layerList,
                  // group: "top-right"
                })
                var layersInfo = []
                var webmapLayers = current.webmap.layers.toArray();
                webmapLayers.forEach(function(item, i) {
                  var layerItem = {}
                  layerItem.layer = item
                  layerItem.title = item.title
                  layersInfo.push(layerItem)
                });
                current.legendList = new Legend({
                  view: current.view,
                  layersInfos: layersInfo
                });
                current.expandLegend = new Expand({
                  view: current.view,
                  expandTooltip: "Legend",
                  collapseTooltip: "Legend",
                  content: current.legendList,
                }),
                current.basemapGallery = new BasemapGallery({
                  view: current.view
                });
                current.expandBaseMapGallery = new Expand({
                  view: current.view,
                  expandTooltip: "Basemap Gallery",
                  collapseTooltip: "Basemap Gallery",
                  content: current.basemapGallery,
                }),
                current.search = new Search({
                  view: current.view
                });
                current.expandSearch = new Expand({
                  view: current.view,
                  expandTooltip: "Search",
                  collapseTooltip: "Search",
                  content: current.search,
                }),
                current.view.ui.add(current.expandSearch,"top-right")
                current.view.ui.add(current.expandLayerList,"top-right")
                current.view.ui.add(current.expandLegend,"top-right")
                current.view.ui.add(current.expandBaseMapGallery,"top-right")
                current.view.ui.add(current.expandScreenshot,"top-right")
                current.view.ui.add(current.fullscreen,"top-right")
                // top left widgets
                current.home = new Home({
                  view: current.view
                })
                current.view.ui.add(current.home, {
                  position: "top-left",
                  index: 0
                })
                var logoDiv = document.getElementById(current.prefixID + "-logoDiv")
                current.view.ui.add(logoDiv, {
                  position: "top-left",
                  index: 0
                });

              })
          })
      })
    },
    methods: {
      makeID: function(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      },
      screenshotBtnClick: function() {
        const current = this
        var view = current.view
        var screenshotBtn = document.getElementById(current.prefixID + '-screenshotBtn')
        current.expandScreenshot.collapse()
        screenshotBtn.classList.add("active")
        var appMap = document.getElementById(current.prefixID + '-gis2dViewer')
        appMap.style.cursor = "crosshair";
        let area = null;
        let maskArea = null;
        var client = {}
        const dragHandler = view.on("drag", function(event) {
          event.stopPropagation();
          // console.log(event.origin.x);
          // console.log(event.x);
          // console.log(event.origin.y);
          // console.log(event.y);
          if (!client.x) {
            client.x = event.native.clientX
            client.y = event.native.clientY
          }
          console.log(client);
          if (event.action !== "end") {
            const xmin = current.clamp(
              Math.min(event.origin.x, event.x),
              0,
              view.width
            );
            const xmax = current.clamp(
              Math.max(event.origin.x, event.x),
              0,
              view.width
            );
            const ymin = current.clamp(
              Math.min(event.origin.y, event.y),
              0,
              view.height
            );
            const ymax = current.clamp(
              Math.max(event.origin.y, event.y),
              0,
              view.height
            );
            area = {
              x: xmin,
              y: ymin,
              width: xmax - xmin,
              height: ymax - ymin
            };
            maskArea = {
              x: client.x,
              y: client.y,
              width: xmax - xmin,
              height: ymax - ymin
            }
            current.setMaskPosition(maskArea);
          } else {
            dragHandler.remove();
            view
              .takeScreenshot({
                area: area,
                format: "png"
              })
              .then(function(screenshot) {
                current.showPreview(screenshot);

                document.getElementById(current.prefixID + '-downloadBtn').onclick = function() {
                  const text = document.getElementById(current.prefixID + '-textInput').value;
                  if (text) {
                    const dataUrl = current.getImageWithText(screenshot, text);
                    current.downloadImage(
                      current.webmap.portalItem.title + ".png",
                      dataUrl
                    );
                  } else {
                    current.downloadImage(
                      current.webmap.portalItem.title + ".png",
                      screenshot.dataUrl
                    );
                  }
                };

                screenshotBtn.classList.remove("active");
                // view.container.classList.remove("screenshotCursor");
                appMap.style.cursor = "auto";
                current.setMaskPosition(null);
              });
          }
        });
      },
      clamp: function(value, from, to) {
        return value < from ? from : value > to ? to : value;
      },
      setMaskPosition: function(area) {
        const current = this
        var maskDiv = document.getElementById(current.prefixID + '-maskDiv')
        if (area) {
          maskDiv.classList.remove("hide");
          maskDiv.style.left = area.x + "px";
          maskDiv.style.top = area.y + "px";
          maskDiv.style.width = area.width + "px";
          maskDiv.style.height = area.height + "px";
        } else {
          maskDiv.classList.add("hide");
        }
      },
      showPreview: function(screenshot) {
        const current = this
        const screenshotDiv = document.getElementById(current.prefixID + "-screenshotDiv");
        screenshotDiv.classList.remove("hide");
        // const screenshotImage = document.getElementsByClassName(
        //   "js-screenshot-image"
        // )[0];
        const screenshotImage = document.getElementById(current.prefixID + "-screenshotImage");
        screenshotImage.width = screenshot.data.width;
        screenshotImage.height = screenshot.data.height;
        screenshotImage.src = screenshot.dataUrl;
      },
      getImageWithText: function(screenshot, text) {
        const imageData = screenshot.data;
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = imageData.height;
        canvas.width = imageData.width;

        context.putImageData(imageData, 0, 0);
        context.font = "20px Arial";
        context.fillStyle = "#000";
        context.fillRect(
          0,
          imageData.height - 40,
          context.measureText(text).width + 20,
          30
        );

        context.fillStyle = "#fff";
        context.fillText(text, 10, imageData.height - 20);

        return canvas.toDataURL();
      },
      downloadImage: function(filename, dataUrl) {
        if (!window.navigator.msSaveOrOpenBlob) {
          const element = document.createElement("a");
          element.setAttribute("href", dataUrl);
          element.setAttribute("download", filename);
          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        } else {
          const byteString = atob(dataUrl.split(",")[1]);
          const mimeString = dataUrl
            .split(",")[0]
            .split(":")[1]
            .split(";")[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          const blob = new Blob([ab], {
            type: mimeString
          });
          window.navigator.msSaveOrOpenBlob(blob, filename);
        }
      },
      screenshotCloseClick: function() {
        const current = this
        const screenshotDiv = document.getElementById(current.prefixID + '-screenshotDiv')
        screenshotDiv.classList.add("hide");
      },
    }
  }
</script>

<style lang="css" scoped>
  .gis2dViewer{
    width: 100%;
    height: 100%;
    /* min-height: 100vh; */
    /* padding: 0;
    margin: 0;
    width: 100%;
    height: 93vh; */
    /* background-color: green; */
  }
  .gisMap {
    width: 100%;
    height: 100%;
    /* min-height: 100vh; */
    /* padding: 0;
    margin: 0;
    width: 100%;
    height: 93vh; */
    /* background-color: green; */
  }
  .screenshotDiv {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 1;
  }
  .hide {
    display: none;
  }
  .active {
    background: #0079c1;
    color: #e4e4e4;
  }
  .screenshotCursor {
    cursor: crosshair;
  }
  .screenshotBtnDiv {
    padding: 10px;
    width: 260px;
    bottom: 15px;
    right: 10px;
    font-size: 14px;
    /* display: none; */
  }
  .maskDiv {
    position: absolute;
    background: rgba(255, 51, 0, 0.1);
    border: 2px dashed rgb(255, 51, 0);
  }
  .screenshotDiv > * {
    margin: 0.5em;
  }
</style>
